import React, { useState } from "react";
import { HiOutlineEye } from "react-icons/hi";
import { sanitizeDocumentUrl } from "../../Utils/utils";
import { openDocumentPreviewInNewTab } from "../../Utils/attachmentPreview";

const GoogleDocsViewer = ({ url }) => {
  const [isLoading, setIsLoading] = useState(false);
  const safeUrl = url ? sanitizeDocumentUrl(url) : null;

  if (!safeUrl) {
    return (
      <div className="gap-x-3 flex bg-red-500">
        <button
          className="icon-eye-wrapper"
          title="View"
          disabled
          style={{ cursor: "not-allowed" }}
        >
          <HiOutlineEye className="icon-size" />
        </button>
      </div>
    );
  }

  const handleView = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);
    try {
      await openDocumentPreviewInNewTab(safeUrl, { isFullUrl: true });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="gap-x-3 flex">
      <a
        href={safeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="icon-eye-wrapper"
        title="View"
        onClick={handleView}
        style={isLoading ? { cursor: "wait", opacity: 0.6 } : undefined}
        aria-busy={isLoading}
      >
        <HiOutlineEye className="icon-size" />
      </a>
    </div>
  );
};

export default GoogleDocsViewer;
